var Layout    = require("enyo/Layout"),
    kind      = require("enyo/kind"),
    themeVars = require("app/theme/variables.js");

require("app/theme/IconButton--play-pause-overlay.less");
require("app/theme/IconButton--transparent-light.less");

module.exports = kind(/** @lends  app.MediaPlayer.VideoViewLayout.prototype */ {

    /**
     * @private
     */
    name: "app.MediaPlayer.VideoViewLayout",

    /**
     * @private
     */
    kind: Layout,

    /**
     * @public
     */
    reflow: function() {
        var container  = this.container,
            appView    = container.app.view,
            controller = container.controller,
            $player    = container.getPlayerTech();

        if (!appView.hasNode() || !container.hasNode() || !controller || !$player || !$player.hasNode()) {
            return;
        }

        switch (controller.get("displayMode")) {
            case "minimized":
                themeVars.windowWidth <= 480 || themeVars.windowHeight <= 360
                    ? this.minimizedLayout()
                    : this.pictureInPictureLayout();
                break;
            case "maximized":
            default:
                this.maximizedLayout();
                break;
        }
    },

    /**
     * Displays the media player at full size. Filling the entire contentRegion
     * of the app layout.
     */
    maximizedLayout: function() {
        var container           = this.container,
            appView             = container.app.view,
            $player             = container.getPlayerTech(),
            headerRegionBounds  = appView.get("headerRegionBounds") || {},
            contentRegionBounds = appView.get("contentRegionBounds") || {},
            headerRegionHeight  = headerRegionBounds.height || 0,
            contentRegionHeight = contentRegionBounds.height || 0,
            contentRegionWidth  = contentRegionBounds.width || 0,
            viewerWidth,
            viewerHeight,
            top                 = 0,
            bottom              = 0,
            left                = 0,
            right               = 0;

        // Make sure all things we need are displaying. At this point they may
        // still be visibly hidden.
        !$player.get("showing") && this.visuallyHideControl($player);

        // Switch styles as needed
        container.setAttribute("data-display-mode", "maximized");

        // Calculate Layout
        viewerWidth  = contentRegionWidth;
        viewerHeight = contentRegionHeight;
        top          += headerRegionHeight;

        if (themeVars.appHeaderFloat === true) {
            viewerHeight -= headerRegionHeight;
        }

        if (!$player.get("supportsSafeArea")) {
            viewerWidth  -= themeVars.safeAreaInsetLeft + themeVars.safeAreaInsetRight;
            viewerHeight -= themeVars.safeAreaInsetBottom;
            left         += themeVars.safeAreaInsetLeft;
            right        += themeVars.safeAreaInsetRight;
            bottom       += themeVars.safeAreaInsetBottom;
        }

        // Apply layout
        container.setBounds({
            width:  viewerWidth,
            height: viewerHeight,
            top:    top,
            right:  bottom,
            bottom: left,
            left:   right
        });

        $player.setBounds({
            width:  viewerWidth,
            height: viewerHeight,
            top:    0,
            right:  0,
            bottom: 0,
            left:   0
        });
        $player.showControls();

        // Show everything we need
        this.showControl($player);
    },

    /**
     * Displays the media player in the bottom-right of the screen.
     */
    pictureInPictureLayout: function() {
        var container           = this.container,
            $player             = container.getPlayerTech(),
            $metadata           = container.$.metadata,
            $expandButton       = container.$.expandButton,
            $playPauseButton    = container.$.playPauseButton,
            $closeButton        = container.$.closeButton,
            contentRegionBounds = container.app.view.get("contentRegionBounds") || {},
            contentWidth        = contentRegionBounds.width || 0,
            metadataNode        = $metadata.hasNode(),
            playerWidth,
            playerHeight,
            metadataHeight;

        // Make sure all things we need are displaying. At this point they may
        // still be visibly hidden.
        !$player.get("showing") && this.visuallyHideControl($player);
        !$metadata.get("showing") && this.visuallyHideControl($metadata);
        !$expandButton.get("showing") && this.visuallyHideControl($expandButton);
        !$playPauseButton.get("showing") && this.visuallyHideControl($playPauseButton);
        !$closeButton.get("showing") && this.visuallyHideControl($closeButton);

        // Switch styles as needed
        container.setAttribute("data-display-mode", "picture-in-picture");
        $playPauseButton.set("theme", "play-pause-overlay");

        // Calculate Layout
        playerWidth    = Math.min(Math.max(contentWidth * 0.2, 320), 480);
        playerHeight   = Math.round(playerWidth / 16 * 9);
        $metadata.setBounds({
            width:  playerWidth,
            height: "auto"
        });
        metadataHeight = Math.round(metadataNode ? metadataNode.offsetHeight : 0);

        // Apply layout
        $player.setBounds({
            width:  playerWidth,
            height: playerHeight,
            top:    0,
            right:  0,
            bottom: "initial",
            left:   0
        });
        $player.hideControls();
        $metadata.setBounds({
            width:  playerWidth,
            height: metadataHeight,
            top:    playerHeight,
            right:  0,
            bottom: "initial",
            left:   0
        });
        $expandButton.setBounds({
            width:  "auto",
            height: "auto",
            top:    0,
            right:  "initial",
            bottom: "initial",
            left:   0
        });
        $playPauseButton.setBounds({
            width:  playerWidth,
            height: playerHeight,
            top:    0,
            right:  0,
            bottom: "initial",
            left:   0
        });
        $closeButton.setBounds({
            width:  "auto",
            height: "auto",
            top:    0,
            right:  0,
            bottom: "initial",
            left:   "initial"
        });
        container.setBounds({
            width:  playerWidth,
            height: playerHeight + metadataHeight + themeVars.safeAreaInsetBottom,
            top:    "initial",
            right:  Math.max(
                themeVars.safeAreaInsetRight + themeVars.getPageMarginPx(),
                themeVars.getPageMarginLargePx()
            ),
            bottom: 0,
            left:   "initial"
        });

        // Show everything we need
        this.showControl($player);
        this.showControl($metadata);
        this.showControl($expandButton);
        this.showControl($playPauseButton);
        this.showControl($closeButton);
    },

    /**
     * Displays the media player at the bottom of the screen.
     */
    minimizedLayout: function() {
        var container           = this.container,
            $player             = container.getPlayerTech(),
            $metadata           = container.$.metadata,
            $expandButton       = container.$.expandButton,
            $playPauseButton    = container.$.playPauseButton,
            $closeButton        = container.$.closeButton,
            appView             = container.app.view,
            contentRegionBounds = appView.get("contentRegionBounds") || {},
            contentWidth        = contentRegionBounds.width || 0,
            containerPadding,
            playerHeight,
            playerWidth,
            closeButtonNode     = $closeButton.hasNode(),
            closeButtonWidth,
            playPauseButtonNode = $playPauseButton.hasNode(),
            playPauseButtonWidth;

        // Make sure all things we need are displaying. At this point they may
        // still be visibly hidden.
        !$player.get("showing") && this.visuallyHideControl($player);
        !$metadata.get("showing") && this.visuallyHideControl($metadata);
        !$expandButton.get("showing") && this.visuallyHideControl($expandButton);
        !$playPauseButton.get("showing") && this.visuallyHideControl($playPauseButton);
        !$closeButton.get("showing") && this.visuallyHideControl($closeButton);

        // Switch styles as needed
        container.setAttribute("data-display-mode", "minimized");
        $playPauseButton.set("theme", "transparent-light");

        // Calculate Layout
        containerPadding = {
            top:    0,
            right:  themeVars.safeAreaInsetRight,
            bottom: themeVars.safeAreaInsetBottom,
            left:   themeVars.safeAreaInsetLeft
        };
        playerHeight     = Math.round((
            themeVars.getBodyFontSizePx()
            * themeVars.headerLineHeight
            * 2
            * themeVars.fontSizeSmall
        ) + (
            themeVars.getContentPaddingVerticalPx() * 2
        ));
        playerWidth      = Math.round(playerHeight / 9 * 16);

        $playPauseButton.setBounds({
            width:  "auto",
            height: playerHeight
        });
        playPauseButtonWidth = playPauseButtonNode ? playPauseButtonNode.offsetWidth : 0;

        $closeButton.setBounds({
            width:  "auto",
            height: playerHeight
        });
        closeButtonWidth = closeButtonNode ? closeButtonNode.offsetWidth : 0;

        // Apply layout
        container.setBounds({
            width:  contentWidth,
            height: playerHeight + containerPadding.bottom,
            top:    "initial",
            right:  0,
            bottom: 0,
            left:   0
        });
        $player.setBounds({
            width:  playerWidth,
            height: playerHeight,
            top:    0,
            right:  "initial",
            bottom: containerPadding.bottom,
            left:   containerPadding.left
        });
        $player.hideControls();
        $metadata.setBounds({
            width: (
                contentWidth
                - containerPadding.left
                - playerWidth
                - playPauseButtonWidth
                - closeButtonWidth
                - containerPadding.right
            ),
            height: playerHeight,
            top:    0,
            right:  "initial",
            bottom: containerPadding.bottom,
            left:   containerPadding.left + playerWidth
        });
        $expandButton.setBounds({
            width: (
                contentWidth
                - containerPadding.left
                - playPauseButtonWidth
                - closeButtonWidth
                - containerPadding.right
            ),
            height: playerHeight,
            top:    0,
            right:  "initial",
            bottom: containerPadding.bottom,
            left:   containerPadding.left
        });
        $playPauseButton.setBounds({
            width:  playPauseButtonWidth,
            height: playerHeight,
            top:    0,
            right:  closeButtonWidth + containerPadding.right,
            bottom: containerPadding.bottom,
            left:   "initial"
        });
        $closeButton.setBounds({
            width:  closeButtonWidth,
            height: playerHeight,
            top:    0,
            right:  containerPadding.right,
            bottom: containerPadding.bottom,
            left:   "initial"
        });

        // Show everything we need
        this.showControl($player);
        this.showControl($metadata);
        this.showControl($expandButton);
        this.showControl($playPauseButton);
        this.showControl($closeButton);
    },

    /**
     * Fully hides the control
     *
     * @param  {enyo.Control}  control  The control
     * @private
     */
    hideControl: function(control) {
        control.hide();
    },

    /**
     * Ensures the control is displayed in the DOM. It might still be visually
     * hidden, but it will have a working box-model.
     *
     * @param  {enyo.Control}  control  The control
     * @private
     */
    visuallyHideControl: function(control) {
        // Sometimes Chrome doesn't properly update dimensions when using
        // visibility hidden, so we make sure the control is just *slightly*
        // visible. This forces Chrome to calculate it's properties correctly.
        control.applyStyle("opacity", 0.001);
        control.show();
    },

    /**
     * Fully reveals the control
     *
     * @param  {enyo.Control}  control  The control
     * @private
     */
    showControl: function(control) {
        control.applyStyle("opacity", null);
        control.show();
    }

});
